import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {
    deleteInsuranceRate,
    getCurrentInsuranceRate,
    resetDeleteInsuranceRateStatus,
} from "../../store/reducers/InsuranceRatesSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";

interface DeleteInsuranceRatesScreenProps {
}

export const DeleteInsuranceRateScreen: React.FC<DeleteInsuranceRatesScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const insuranceRateState = useAppSelector(
        (state) => state.insuranceRates
    );
    const requestStatus: RequestStatus =
        insuranceRateState.deleteInsuranceRateStatus;

    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Kindlustuse hinnad", url: "/insurance"},
        {text: "Kindlustuse hinna kustutamine", url: `/insurance/${id}/delete`,},
    ];

    useEffect(() => {
        dispatch(resetDeleteInsuranceRateStatus());
    }, [location]);

    const handleConfirm = () => {
        dispatch(deleteInsuranceRate({id}));
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        dispatch(getCurrentInsuranceRate({id}));
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Kindlustuse hind kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid kindlustuse hinna kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};